import { render } from "./AppSettings.vue?vue&type=template&id=2943f313&ts=true"
import script from "./AppSettings.vue?vue&type=script&lang=ts"
export * from "./AppSettings.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__